export default "__VITE_ASSET__5a7b7a38__"